import { render, staticRenderFns } from "./CommunicationsSection.vue?vue&type=template&id=67d0450c&"
import script from "./CommunicationsSection.vue?vue&type=script&lang=js&"
export * from "./CommunicationsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports